import { jsx as _jsx } from "react/jsx-runtime";
import { SobQuestion } from "@jti/ui/components/SobQuiz/SobQuestion";
import { useTranslations } from "../../../providers/useTranslations";
export const SobCaptureConsent = ({ data, onConsentSelect, consentData, isPending = false, }) => {
    const { __ } = useTranslations();
    const { title, description } = data;
    return (_jsx("div", { children: _jsx(SobQuestion, { isPending: isPending, question: {
                question: { id: "consent", title: consentData ? consentData.description : "" },
                possibleAnswers: [
                    { id: "yes", title: __("sob.consent.yes"), referenceName: "", localTranslation: __("sob.consent.yes") },
                    { id: "no", title: __("sob.consent.no"), referenceName: "", localTranslation: __("sob.consent.no") },
                ],
            }, title: title, description: description, onAnswerSelect: (answerId) => {
                onConsentSelect(answerId === "yes");
            } }) }));
};
//# sourceMappingURL=SobCaptureConsent.js.map